import {
    IBoltSubscriptionTwoStepsRequest,
    IBoltSubscriptionTwoStepsResponse,
} from '../../../entity/interface/iSubscription';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { container } from '../../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IBoltUserSubscriptionTwoStepsUseCase {
    execute(
        payload: IBoltSubscriptionTwoStepsRequest,
        apiToken: { [key: string]: string }
    ): Promise<IBoltSubscriptionTwoStepsResponse>;
}

export class BoltUserSubscriptionTwoStepsUseCase implements IBoltUserSubscriptionTwoStepsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        payload: IBoltSubscriptionTwoStepsRequest,
        apiToken: { [key: string]: string }
    ): Promise<IBoltSubscriptionTwoStepsResponse> {
        return await this.subscriptionRepository.boltUserSubscriptionTwoSteps(payload, apiToken);
    }
}
